import { NOTIFY } from '@/constants/notification-messages';
import { emitter } from '@/main';

export const useNotification = () => {
    let withdrawalsEventStream;

    const initializeSSE = () => {
        withdrawalsEventStream = new EventSource('/api/notify/');

        withdrawalsEventStream.onmessage = function (e) {
            const data = JSON.parse(e.data);
            handleNotifyEvent(data);
        };
    };

    const listenWorker = () => {
        const worker = new SharedWorker('/sw.js');
        worker.port.postMessage('Start');
        worker.port.onmessage = e => {
            const { data } = e;
            handleNotifyEvent(data);
        };
    };

    const destroySSE = () => {
        withdrawalsEventStream.close();
    };

    const handleNotifyEvent = data => {
        switch (data.type) {
        case NOTIFY.WITHDRAWAL_REQUEST_UPDATED:
            emitter.emit(NOTIFY.WITHDRAWAL_REQUEST_UPDATED, data.data);
            break;
        case NOTIFY.WITHDRAWAL_REQUEST_CREATED:
            emitter.emit(NOTIFY.WITHDRAWAL_REQUEST_CREATED, data.data);
            break;
        case NOTIFY.CHAT_MESSAGE:
            emitter.emit(NOTIFY.CHAT_MESSAGE, data.data);
            break;
        case NOTIFY.CHAT_MESSAGE_DELETED:
            emitter.emit(NOTIFY.CHAT_MESSAGE_DELETED, data.data);
            break;
        case NOTIFY.ARTIFACT_NEW:
            emitter.emit(NOTIFY.ARTIFACT_NEW);
            break;
        case NOTIFY.ARTIFACT_EMPTY:
            emitter.emit(NOTIFY.ARTIFACT_EMPTY);
            break;
        case NOTIFY.ARTIFACT_ERROR:
            emitter.emit(NOTIFY.ARTIFACT_ERROR, data.description);
            break;
        default:
            break;
        }
    };

    return {
        withdrawalsEventStream,
        initializeSSE,
        listenWorker,
        destroySSE,
    };
};
